module.exports = __webpack_public_path__ + "static/hero-dots-7ff226721edc20e9a8f0ae75ce8a6787.webp";